export default __webpack_public_path__ + "static/media/by_10.c4896eff.mp3";